import React from 'react'
import { connect } from 'react-redux'

import { receiptSelectors } from '../../core/receipt'
import ShowMath from '../components/ShowMath'
import VenmoUrl from '../components/VenmoUrl'

class Calculations extends React.Component {
  render () {
    const amount = isNaN(this.props.personalGrandTotal) ? 0 : this.props.personalGrandTotal
    const personalTotal = isNaN(this.props.personalTotal) ? 0 : this.props.personalTotal
    const personalTax = isNaN(this.props.personalTax) ? 0 : this.props.personalTax
    const personalTip = isNaN(this.props.personalTip) ? 0 : this.props.personalTip

    return (
      <div>
        <p>You owe ${amount.toFixed(2)}</p>
        <ShowMath personalTotal={personalTotal} personalTax={personalTax} personalTip={personalTip} />
        <VenmoUrl amount={amount}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  // todo move this to its own module and test it
  const totalPreTax = receiptSelectors.getTotalPreTax(state)

  const personalTotal = receiptSelectors.getItems(state).map(a => a.price * (1 / a.split)).reduce((a, b) => a + b, 0)
  const taxRate = receiptSelectors.getTaxCost(state) / totalPreTax
  const personalTax = personalTotal * taxRate
  const tipRate = receiptSelectors.getTipCost(state) / totalPreTax
  const personalTip = personalTotal * tipRate
  const personalGrandTotal = personalTotal + personalTax + personalTip

  return {
    personalTotal,
    personalTax,
    personalTip,
    personalGrandTotal
  }
}

export default connect(mapStateToProps)(Calculations)



/** WEBPACK FOOTER **
 ** ./src/views/containers/Calculations.js
 **/